import { PERMISSIONS, ROLE_PERMISSIONS, USER_ROLES } from './flowdeskDataModel';

export const SETTINGS_TAB_ACCESS_OPTIONS = Object.freeze([
  { id: 'company', labelAr: 'الشركة', labelEn: 'Company', group: 'company' },
  { id: 'clients', labelAr: 'العملاء', labelEn: 'Clients', group: 'company' },
  { id: 'managers', labelAr: 'المسؤولين', labelEn: 'Managers', group: 'company' },
  { id: 'hours', labelAr: 'ساعات العمل', labelEn: 'Working hours', group: 'company' },
  { id: 'appearance', labelAr: 'المظهر', labelEn: 'Appearance', group: 'program' },
  { id: 'backup', labelAr: 'النسخ الاحتياطي', labelEn: 'Backup', group: 'program' },
  { id: 'sound', labelAr: 'مواقيت الأذان', labelEn: 'Prayer times', group: 'program' },
  { id: 'health', labelAr: 'منبه الصحة', labelEn: 'Health reminder', group: 'program' },
  { id: 'profile', labelAr: 'الملف الشخصي', labelEn: 'Profile', group: 'program' },
  { id: 'about', labelAr: 'عن البرنامج', labelEn: 'About', group: 'program' }
]);

export const normalizeAccessRole = (role) => {
  if (Object.values(USER_ROLES).includes(role)) return role;
  return USER_ROLES.owner;
};

export const getPermissionsForRole = (role) => {
  const normalizedRole = normalizeAccessRole(role);
  return ROLE_PERMISSIONS[normalizedRole] || [];
};

export const hasPermissionForRole = ({ role, permission }) => {
  if (!permission) return true;

  const permissions = getPermissionsForRole(role);
  return permissions.includes(permission);
};

export const createPermissionContext = ({ role = USER_ROLES.owner, user = null } = {}) => {
  const accessRole = normalizeAccessRole(role);
  const customSettingsTabs = Array.isArray(user?.settingsTabs) ? user.settingsTabs.map(String) : [];
  const allowedSettingsTabs = accessRole === USER_ROLES.owner
    ? null
    : new Set(customSettingsTabs.length ? customSettingsTabs : ['profile']);

  return {
    accessRole,
    permissions: getPermissionsForRole(accessRole),
    hasPermission: (permission) => hasPermissionForRole({ role: accessRole, permission }),
    requirePermission: (permission) => hasPermissionForRole({ role: accessRole, permission }),
    canAccessSettingsTab: (tabId) => {
      if (accessRole === USER_ROLES.owner) return true;
      if (tabId === 'users' || tabId === 'sync') return false;
      return Boolean(allowedSettingsTabs?.has(tabId));
    }
  };
};
